import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

const formatStartDate = (date) =>
	date && date.isValid && date.isValid() ? date.startOf("day").toISOString() : "";

const formatEndDate = (date) =>
	date && date.isValid && date.isValid() ? date.endOf("day").toISOString() : "";

export const fetchPettyCashCommonRequestApprovalList = createAsyncThunk(
	"fetchPettyCashCommonRequestApprovalList",
	async ({ filters }) => {
		const params = new URLSearchParams({
			page: filters?.page ?? 1,
			limit: filters?.limit ?? 10,
		});

		if (filters?.keyword) {
			params.set("keyword", filters.keyword);
		}

		if (filters?.status) {
			params.set("status", filters.status);
		}

		if (filters?.department_id) {
			params.set("department", filters.department_id);
		}

		const startDate = filters?.dateRange?.[0] ? formatStartDate(filters.dateRange[0]) : "";
		const endDate = filters?.dateRange?.[1] ? formatEndDate(filters.dateRange[1]) : "";

		if (startDate) {
			params.set("start_date", startDate);
		}

		if (endDate) {
			params.set("end_date", endDate);
		}

		try {
			const response = await axiosHttp.get(`petty-cash/common-requests?${params}`);
			return response.data;
		} catch (error) {
			throw error;
		}
	}
);

const PettyCashCommonRequestApprovalListSlice = createSlice({
	name: "PettyCashCommonRequestApprovalListSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		page: 1,
		limit: 10,
		total: 0,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchPettyCashCommonRequestApprovalList.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchPettyCashCommonRequestApprovalList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
			state.page = action.payload?.pagination?.page || 1;
			state.limit = action.payload?.pagination?.limit || 10;
			state.total = action.payload?.pagination?.total || (action.payload?.data ? action.payload.data.length : 0);
		});

		builder.addCase(fetchPettyCashCommonRequestApprovalList.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default PettyCashCommonRequestApprovalListSlice.reducer;
